// extracted by mini-css-extract-plugin
module.exports = {"accordion-item-content":"AccordionItemContent_accordion-item-content__ehWw7","accordion-item-content-pickup":"AccordionItemContent_accordion-item-content-pickup__aMYbF"};